import { Injectable } from "@angular/core";
@Injectable({
  providedIn: "root"
})
export class CalendarService {

  private rangeHoursOperation = 1;
  private daysWeekend = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
  }

  public get dateNow() {
    return new Date();
  }

  public get getDay(): { index: number, label: string, dateNumber: number, date } {

    const index = this.dateNow.getDay();

    return {
      index,
      label: this.daysWeekend[index],
      dateNumber: this.dateNow.getDate(),
      date: this.dateNow
    };
  }

  public createDaysWeek() {

    const listDaysWeek = [];
    const rangeWeek = 6;

    listDaysWeek.push(this.getDay);

    for (let i = 1; i <= rangeWeek; i++) {

      let fowardDay = this.getDay.index + i;
      let date = this.getDay.date as Date;
      var followingDay = new Date(date.getTime() + 86400000 * i);
      if (fowardDay > rangeWeek) {
        fowardDay = fowardDay - rangeWeek - 1;
      }
      const dayWeek = {
        dateNumber: followingDay.getDate(),
        index: fowardDay,
        label: this.daysWeekend[fowardDay],
        date: followingDay.toLocaleString()
      };
      listDaysWeek.push(dayWeek);
    }



    return listDaysWeek;

  }

  public createRangeDatesOperation(hoursOperation, dayWeekSelected) {

    const { horarioConvertidoAbertura, horarioConvertidoFechamento, horariosDisponiveis } = hoursOperation.find(hours => dayWeekSelected.label == hours.diaSemana);

    let listHours = [];

    if (!horariosDisponiveis.length && horarioConvertidoAbertura && horarioConvertidoFechamento) {
      for (let i = horarioConvertidoAbertura; i <= horarioConvertidoFechamento; i += 0.5) {

        const rest = i % 1 === 0 ? '00' : '30';

        let hourInteger = i % 1 === 0 ? i : i - 0.5;

        let ampmHour = i >= 12 ? `${((i == 12 || i == 12.5) ? 12 : hourInteger - 12)}:${rest}PM` : `${hourInteger}:${rest}AM`;


        if (ampmHour == 'null:00AM') {
          ampmHour = '12:00AM';
        }

        listHours.push({
          horario: i,
          horarioConvertido: ampmHour
        });

      }

      if (horarioConvertidoAbertura > horarioConvertidoFechamento) {
        for (let i = horarioConvertidoAbertura; i < 24; i += 0.5) {

          const rest = i % 1 === 0 ? '00' : '30';

          const hourInteger = i % 1 === 0 ? i : i - 0.5;

          let ampmHour = i >= 12 ? `${((i == 12 || i == 12.5) ? 12 : hourInteger - 12)}:${rest}PM` : `${hourInteger}:${rest}AM`;

          if (i == 0) {
            ampmHour = '12:00AM';
          }

          listHours.push({
            horario: i,
            horarioConvertido: ampmHour
          });

        }
        for (let i = 0; i <= horarioConvertidoFechamento; i++) {

          let ampmHour = i >= 12 ? `${(i == 12 ? 12 : i - 12)}:00PM` : `${i}:00AM`;

          if (i == 0) {
            ampmHour = '12:00AM';
          }

          listHours.push({
            horario: i,
            horarioConvertido: ampmHour
          });

        }
      }
    }

    else {
      listHours = [];
      horariosDisponiveis.forEach(hour => {
        let i = parseInt(hour.split(':')[0]);
        let ampmHour = i >= 12 ? `${(i == 12 ? 12 : i - 12)}:00PM` : `${i}:00AM`;
        listHours.push({
          horario: i,
          horarioConvertido: ampmHour
        });
      });
    }

    return listHours;

  }

  timeConverter(UNIX_timestamp) {
    var a = new Date(UNIX_timestamp);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var sec = a.getSeconds();
    var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
    return time;
  }

}
